import { lazy } from 'react'
import type { RouteConfig } from '../types/route'

/** 懒加载页面组件 */
const LoginPage = lazy(() => import('../pages/login/LoginPage'))
const NotFoundPage = lazy(() => import('../pages/error/NotFoundPage'))

/**
 * 静态路由
 * 不需要权限的路由，如登录页、404 页面
 * 首页等需要权限的路由由后端动态生成
 *
 * Note: title 字段会在运行时通过 i18n 翻译
 * 对于静态路由，title 使用 i18n key，在渲染时会被翻译
 */
export const staticRoutes: RouteConfig[] = [
  {
    path: '/login',
    component: LoginPage,
    title: 'login.title',  // i18n key
    authRequired: false,
    hidden: true,
  },
  // 404 页面
  {
    path: '*',
    component: NotFoundPage,
    title: 'page.notFound',  // i18n key
    hidden: true,
  },
]

/**
 * 动态路由
 * 这些路由会根据后端返回的 menus 数据动态生成
 * 以下路由配置作为备份和参考，保留在注释中
 */
/*
// 基础数据 - 道路管理相关页面
const StaticIndexPage = lazy(() => import('../pages/basic/road/static/StaticIndexPage'))
const RoadTreePage = lazy(() => import('../pages/basic/road/static/RoadTreePage'))
const StructurePage = lazy(() => import('../pages/basic/road/static/StructurePage'))
const GeometryPage = lazy(() => import('../pages/basic/road/static/GeometryPage'))
const TrafficPage = lazy(() => import('../pages/basic/road/static/TrafficPage'))
const HistoryPage = lazy(() => import('../pages/basic/road/static/HistoryPage'))
const RoadPage = lazy(() => import('../pages/basic/road/inspect/InspectPage'))
const SubRoadPage = lazy(() => import('../pages/basic/road/sub/QueryPage'))
const TangentPage = lazy(() => import('../pages/basic/road/tangent/TangentPage'))
// 基础数据 - 历史检测数据
const HistoryIndexPage = lazy(() => import('../pages/basic/road/history/HistoryIndexPage'))
const FwdDataPage = lazy(() => import('../pages/basic/road/history/FwdDataPage'))
const GprDataPage = lazy(() => import('../pages/basic/road/history/GprDataPage'))
const LicsDataPage = lazy(() => import('../pages/basic/road/history/LicsDataPage'))
const IriDataPage = lazy(() => import('../pages/basic/road/history/IriDataPage'))
const DiseaseScanPage = lazy(() => import('../pages/basic/road/history/DiseaseScanPage'))
// 基础数据 - 道路查询
const RoadQueryPage = lazy(() => import('../pages/basic/road/query/RoadQueryPage'))
// 基础数据 - 道路指标
const TangentIndexPage = lazy(() => import('../pages/basic/road/TangentIndexPage'))
// 工程管理 - 养护工程库
const MaintenancePage = lazy(() => import('../pages/basic/engineering/maintenance/MaintenancePage'))
// 工程管理 - 养护方式
const MaintenanceMethodPage = lazy(() => import('../pages/basic/engineering/method/MaintenanceMethodPage'))
// 模型管理
const ModelPerformanceIndexPage = lazy(() => import('../pages/model/index/PerformanceIndexPage'))
const BudgetOptimizationPage = lazy(() => import('../pages/model/optimization/BudgetOptimizationPage'))
const DecisionTreePage = lazy(() => import('../pages/model/tree/DecisionTreePage'))
// 科学决策
const PpiPredictionPage = lazy(() => import('../pages/decision/prediction/PpiPredictionPage'))
const DecisionPpiPredictionIndexPage = lazy(() => import('../pages/decision/prediction/PpiPredictionIndexPage'))
const PpiPredictionRecordPage = lazy(() => import('../pages/decision/prediction/PpiPredictionRecordPage'))
const MaintenanceDecisionPage = lazy(() => import('../pages/decision/maintenance/MaintenanceDecisionPage'))
const MaintenanceDecisionIndexPage = lazy(() => import('../pages/decision/maintenance/MaintenanceDecisionIndexPage'))
const MaintenanceRecordPage = lazy(() => import('../pages/decision/maintenance/MaintenanceRecordPage'))
// 权限管理 - 用户管理
const UserPage = lazy(() => import('../pages/system/user/UserPage'))
const RolePage = lazy(() => import('../pages/system/role/RolePage'))
// 权限管理 - 病害映射
const DiseaseMappingPage = lazy(() => import('../pages/system/mapping/DiseaseMappingPage'))
// 测试页面
const TestPage = lazy(() => import('../pages/test/TestPage'))
// 权限管理 - 配置下拉框
const ConfigOptionPage = lazy(() => import('../pages/system/config/ConfigOptionPage'))
*/

/**
 * 路由配置（已弃用，使用静态路由 + 动态路由）
 * @deprecated 使用 staticRoutes + 动态生成的路由
 */
export const routes: RouteConfig[] = staticRoutes
